<template>
  <nav v-bind="$attrs" id="navbarBlur" class="shadow-none navbar navbar-main navbar-expand-lg" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs class="me-4" :current-page="currentRouteName" />
      <div id="navbar" class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4">
        <div id="search" class="pe-md-3 d-flex align-items-center ms-md-auto">
          <div v-if="false" class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input type="text" class="form-control" id="general_search" :placeholder="'Buscar...'" />
          </div>
        </div>
        <VsudButtonVue color="primary" size="md" class="new-certificate-button" data-bs-toggle="modal" data-bs-target="#certificateCreator" @click="modalOpen()" ><i class="ri-file-text-line pe-2"></i>Generar certificados</VsudButtonVue>
        <ul class="navbar-nav justify-content-end ms-3">
          <!-- <DropdownMenu v-if="name" ref="dropdownMenu" /> -->
          <FilterButton v-if="with_filter" id="rightSideFilter" @click="filterOpen()" filter="true" />
          <li v-if="isDemo" class="nav-item d-flex align-items-center me-3">
            <span class="badge bg-gradient-warning" title="Los datos sensibles están enmascarados">Modo demo</span>
          </li>
          <UserInfo :name="name" :profile="profile" :photo="avatar"></UserInfo>
          <li class="nav-item d-xl-none px-3 d-flex align-items-center">
            <a id="iconNavbarSidenav" href="#" class="p-0 nav-link text-body" @click="toggleSidebar">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <VsudRightSideFilter id="rightSideFilter" title="Filtro" ref="rightSideFilter">
    <form action class="form needs-validation" id="form" @submit.prevent="save_form" novalidate>
      <div id="table_container" class="row">
        <div v-if="showConfigFilter" class="col-12 m-auto mb-4">
          <!-- <VsudButtonVue color="primary" size="md" value="Configuracion" type="button"
            data-bs-toggle="modal" data-bs-target="#configModal" class="col-12">Configuración de campos
          </VsudButtonVue> -->
        </div>
        <VsudDate v-if="showDateStartFilter" title="Fecha de inicio" v-model="date_start_filter" id="date_start_filter"
          name="date_start_filter" placeholder="Seleccione fecha de inicio" :isRequired="false" :showRequired="false"
          class="col-12 col-md-6 col-xl-6" :withTime="withTime"/>
        <VsudDate v-if="showDateEndFilter" title="Fecha de fin" v-model="date_end_filter" id="date_end_filter"
          name="date_end_filter" placeholder="Seleccione fecha de fin" :isRequired="false" :showRequired="false"
          class="col-12 col-md-6 col-xl-6" :withTime="withTime"/>
        <VsudSelectSearch v-if="showClientFilter && canSeeClient" title="Cliente" id="client_filter" name="client_filter"
          v-model:modelValue="client_filter" allFilter="true" typeFilter="client" placeholder="Seleccione cliente"
          :isRequired="false" :showRequired="false" :disableValidation="true"/>
        <VsudSelectSearch v-if="showUserFilter" title="Usuario" id="user_filter" name="user_filter"
          v-model:modelValue="user_filter" allFilter="true" typeFilter="user" placeholder="Seleccione usuario"
          :isRequired="false" :showRequired="false" :disableValidation="true" />
        <VsudSelectSearch v-if="showNameFilter" title="Nombre completo" id="name_filter" name="name_filter"
          v-model:modelValue="name_filter" typeFilter="driver_access_account_name" placeholder="Seleccione nombre"
          :company-id="company_filter" preload :isRequired="false" :showRequired="false" :disableValidation="true" />
        <VsudSelectSearch v-if="showEmailFilter" title="Correo electrónico" id="email_filter" name="email_filter"
          v-model:modelValue="email_filter" typeFilter="driver_access_account_email" placeholder="Seleccione correo"
          :company-id="company_filter" preload :isRequired="false" :showRequired="false" :disableValidation="true" />
        <VsudSelectSearch v-if="showPhoneFilter" title="Teléfono" id="phone_filter" name="phone_filter"
          v-model:modelValue="phone_filter" typeFilter="driver_access_account_phone" placeholder="Seleccione teléfono"
          :company-id="company_filter" preload :isRequired="false" :showRequired="false" :disableValidation="true" />
        <VsudSelectSearch v-if="showImeiFilter" title="IMEI" id="imei_filter" name="imei_filter"
          v-model:modelValue="imei_filter" allFilter="true" typeFilter="device" placeholder="Seleccione IMEI"
          :isRequired="false" :showRequired="false" :disableValidation="true" />

        <VsudSelect v-if="showTypeDeviceFilter" title="Tipo de dispositivo" v-model="type_device_filter" id="type_device_filter" name="type_device_filter"
          placeholder="Seleccione tipo de dispositivo" :items="types_devices" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_devices.length === 0'/>

        <VsudSelect v-if="showStatusFilter" title="Estado de dispositivo GPS" v-model="status_filter" id="status_filter" name="status_filter"
          placeholder="Seleccione estado de dispositivo GPS" :items="statuses" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='statuses.length === 0'/>
        <VsudSelectSearch v-if="showCompanyFilter" title="Mandante" id="company_filter" name="company_filter"
          v-model:modelValue="company_filter" allFilter="true" typeFilter="company" placeholder="Seleccione mandante"
          :protect-only="protectOnlyFilter" :isRequired="false" :showRequired="false" :disableValidation="true" />
        <VsudSelect v-if="showBrandFilter" title="Marca" v-model="brand_filter" id="brand_filter" name="brand_filter"
          placeholder="Seleccione marca" :items="brands" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='brands.length === 0'/>
        <VsudSelect v-if="showModelFilter" title="Modelo" v-model="model_filter" id="model_filter" name="model_filter"
          placeholder="Seleccione modelo" :items="filteredModel" :isRequired="false" :disableSelect='disableSelect' :showRequired="false"
          disableValidation="true"/>
        <VsudSelect v-if="showTypeVehicleFilter" title="Tipo de vehículo" v-model="type_vehicle_filter" id="type_vehicle_filter" name="type_vehicle_filter"
          placeholder="Seleccione tipo de vehículo" :items="types_vehicles" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_vehicles.length === 0'/>
        <VsudSelect v-if="showSpeedTypeFilter" title="Condición" v-model="speed_type_filter" id="speed_type_filter" name="speed_type_filter"
          :items="ranges_types" :isRequired="false" :showRequired="false"
          disableValidation="true" />
        <VsudInputVue v-if="showSpeedFilter" title="km/h" v-model="speed_filter" id="speed_filter" name="speed_filter"
          type="number" :isRequired="false" :showRequired="false" disableValidation="true" />
        <VsudSelect v-if="showMileageTypeFilter" title="Condición" v-model="mileage_type_filter" id="mileage_type_filter" name="mileage_type_filter"
          :items="ranges_types" :isRequired="false" :showRequired="false"
          disableValidation="true" />
        <VsudInputVue v-if="showMileageFilter" title="Kilómetros" v-model="mileage_filter" id="mileage_filter" name="mileage_filter"
          type="number" :isRequired="false" :showRequired="false" disableValidation="true" />
        <VsudSelect v-if="showMinuteTypeFilter" title="Condición" v-model="minute_type_filter" id="minute_type_filter" name="minute_type_filter"
          :items="ranges_types" :isRequired="false" :showRequired="false"
          disableValidation="true" />
        <VsudInputVue v-if="showMinuteFilter" title="Minutos" v-model="minute_filter" id="minute_filter" name="minute_filter"
          type="number" :isRequired="false" :showRequired="false" disableValidation="true" />
        <VsudSelect v-if="showDaysTypeFilter" title="Condición" v-model="days_type_filter" id="days_type_filter" name="days_type_filter"
          :items="ranges_types" :isRequired="false" :showRequired="false"
          disableValidation="true" />
        <VsudInputVue v-if="showDaysFilter" title="Días" v-model="days_filter" id="days_filter" name="days_filter"
          type="number" :isRequired="false" :showRequired="false" disableValidation="true" :applyPercentLimits="true" @input="limitDaysRange"/>
        <VsudSelectSearch v-if="showZoneFilter" title="Zona" id="zone_filter" name="zone_filter"
          v-model:modelValue="zone_filter" allFilter="true" typeFilter="zone" placeholder="Seleccione zona"
          :isRequired="false" :showRequired="false" :disableValidation="true" />
        <VsudSelectMultipleSearch v-if="showZonesFilter" title="Zonas" id="zones_filter" name="zones_filter"
          v-model:modelValue="zones_filter" typeFilter="zone" placeholder="Seleccione zonas" :isRequired="false"
          :showRequired="false" :filterSide="true" :disableValidation="true" /> 

        <VsudSelect v-if="showTypeZoneFilter" title="Tipo de zona" v-model="type_zone_filter" id="type_zone_filter" name="type_zone_filter"
          placeholder="Seleccione tipo de zona" :items="types_zones" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_zones.length === 0'/>

        <VsudSelect v-if="showTypeAreaFilter" title="Tipo de area" v-model="type_area_filter" id="type_area_filter" name="type_area_filter"
          placeholder="Seleccione tipo de area" :items="types_areas" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_areas.length === 0'/>

        <VsudSelectSearch v-if="showPlateFilter" title="Patente" id="plate_filter" name="plate_filter"
          v-model:modelValue="plate_filter" typeFilter="vehicle" placeholder="Seleccione patente" :isRequired="false"
          :showRequired="false" :disableValidation="true" :protect-only="protectOnlyFilter" />

        <VsudSelectSearch v-if="showAliasFilter" title="Código interno" id="alias_filter" name="alias_filter"
          v-model:modelValue="alias_filter" typeFilter="vehicle_alias" placeholder="Seleccione código interno" :isRequired="false"
          :showRequired="false" :disableValidation="true" />

        <VsudSelectMultipleSearch v-if="showHighwayFilter" title="Autopistas" id="highway_filter" name="highway_filter"
          v-model:modelValue="highway_filter" typeFilter="highway" placeholder="Seleccione autopistas" :isRequired="false"
          :showRequired="false" :filterSide="true" :disableValidation="true" @update:highways="highway_filter = $event" />

        <VsudSelectMultipleSearch v-if="showPorchFilter" title="Pórticos" id="porch_filter" name="porch_filter"
          v-model:modelValue="porch_filter" typeFilter="porch" placeholder="Seleccione porticos" :isRequired="false"
          :showRequired="false" :filterSide="true" :disableValidation="true" :selectedHighways="highway_filter" /> 

        <VsudSelectMultipleSearch v-if="showVehicleGroupsFilter" title="Grupos" id="vehicle_groups_filter" name="vehicle_groups_filter"
          v-model:modelValue="vehicle_groups_filter" typeFilter="vehicle_group" placeholder="Seleccione grupos" :isRequired="false"
          :showRequired="false" :filterSide="true" :disableValidation="true" />

        <VsudSelectMultipleSearch v-if="showPlatesFilter" title="Patentes" id="plates_filter" name="plates_filter"
          v-model:modelValue="plates_filter" typeFilter="vehicle" placeholder="Seleccione patentes" :isRequired="false"
          :showRequired="false" :filterSide="true" :disableValidation="true" />

        <VsudSelectMultipleSearch v-if="showPlatesPlateFilter" title="Patentes" id="plates_plate_filter" name="plates_plate_filter"
          v-model:modelValue="plates_plate_filter" typeFilter="vehicle_plate" placeholder="Seleccione patentes" :isRequired="false"
          :showRequired="false" :filterSide="true" :disableValidation="true" />

        <VsudSelect v-if="showTypeAlertFilter" title="Tipo de alerta" v-model="type_alert_filter" id="type_alert_filter" name="type_alert_filter"
          placeholder="Seleccione tipo de alerta" :items="types_alert" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_alert.length === 0'/>  
          
        <VsudSelect v-if="showTypeCommandFilter" title="Tipo de Comando" v-model="type_command_filter" id="type_command_filter" name="type_command_filter"
          placeholder="Seleccione tipo de Comando" :items="types_command" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_command.length === 0'/>           

        <VsudSelect v-if="showStatusAlertFilter" title="Estado de alerta" v-model="status_alert_filter" id="status_alert_filter" name="status_alert_filter"
          placeholder="Seleccione estado de alerta" :items="statuses_alert" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='statuses_alert.length === 0'/>

        <VsudSelect v-if="showResultAlertFilter" title="Resultado" v-model="result_alert_filter" id="result_alert_filter" name="result_alert_filter"
          placeholder="Seleccione resultado" :items="results_alert" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='results_alert.length === 0'/>

        <VsudSelect v-if="showTypeRateFilter" title="Tipo de tarifa" v-model="type_rate_filter" id="type_rate_filter" name="type_rate_filter"
          placeholder="Seleccione tipo de tarifa" :items="types_rate" :isRequired="false" :showRequired="false"
          disableValidation="true" :disableSelect='types_rate.length === 0'/>

        <VsudTextarea v-if="showMassivePlatesFilter" title="Listado de patentes" v-model="massive_plates_filter" id="massive_plates_filter" name="massive_plates_filter"
            placeholder="Ingrese las patentes a filtrar" :isRequired="false" :showRequired="false" disableValidation="true" />

        <VsudTextarea v-if="showMassiveChasisNumbersFilter" title="Listado de números de chasis (VIN)" v-model="massive_chasis_numbers_filter" id="massive_chasis_numbers_filter" name="massive_chasis_numbers_filter"
            placeholder="Ingrese los vin a filtrar" :isRequired="false" :showRequired="false" disableValidation="true" />

        <VsudInputVue v-if="showTextFilter" title="Buscador" v-model="text_filter" id="text_filter" name="text_filter"
          type="text" placeholder="buscar..." :isRequired="false" :showRequired="false" disableValidation="true" />
      </div>
      <div class="button-containers-end">
        <VsudButtonVue 
        color="secondary"     
        variant="outline" 
        size="md"   
        @click="clear_clicked()" 
        :load="loadBack"
        type="button"
        value="Login"
        class="px-1 py-0 d-flex align-items-center justify-content-center"
        title="Limpiar filtros"
        >
          <i class="ri-delete-bin-line"></i> 
        </VsudButtonVue>
        <VsudButtonVue 
        v-if="with_save_filter" 
        color="secondary"     
        variant="outline" 
        size="md"   
        value="Login" 
        type="submit" 
        class="form-submit px-1 py-0 d-flex align-items-center justify-content-center"
        @click="savePreferencesFilter()" 
        :load="load"
        title="Guardar configuración de filtros"
        >
          <i class="ri-save-line"></i>
        </VsudButtonVue>
        
        <VsudButtonVue 
        color="primary"     
        size="md" 
        value="Login" 
        type="submit" 
        class="form-submit filter-button-primary"
        @click="clicked()" 
        :load="load">          
          Filtrar
        </VsudButtonVue>
      </div>
    </form>
  </VsudRightSideFilter>
  <div class="modal fade" id="configModal" tabindex="-1" aria-labelledby="configodalLabel" aria-hidden="true">
    <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="imageModalLabel">Configuración de campos</h5>
      </div>
      <div class="modal-body mx-auto">
        <div class="row">
          <div v-for="(fieldName, fieldId) in all_field" :key="fieldId" class="col-12 col-md-6 col-xl-4">
            <VsudCheckbox
              :id="fieldId"
              :modelValue="isFieldSelected(fieldId)"
              @change="toggleCheckboxField(fieldId)"
              class="ms-1"
            >
              {{ fieldName }}
            </VsudCheckbox>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="savePreferences()" data-bs-dismiss="modal">Guardar</button>
        <button type="button" class="btn btn-secondary" @click="closePreferences()"  data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
    </div>
  </div>
  <ModalCertificateCreator ref="modalCertificateCreator" id="certificateCreator" />
</template>
<script>
import Swal from 'sweetalert2';
import { mapGetters, mapMutations, mapActions } from "vuex";
import Breadcrumbs from "./Breadcrumbs.vue";
import FilterButton from './FilterButton.vue';
import UserInfo from "./UserInfo.vue";
import VsudRightSideFilter from '@/components/VsudRightSideFilter.vue';
import securedWebStorage from '@/main';
import avatarDefault from "@/assets/img/avatars/user.jpg";
import VsudSelect from '@/components/VsudSelect.vue';
import VsudButtonVue from "@/components/VsudButton.vue";
import VsudDate from '@/components/VsudDate.vue';
import VsudInputVue from "@/components/VsudInput.vue";
import VsudSelectSearch from "@/components/VsudSelectSearch.vue"
import VsudSelectMultipleSearch from "@/components/VsudSelectMultipleSearch.vue"
import VsudTextarea from '@/components/VsudTextarea.vue';
import VsudCheckbox from '@/components/VsudCheckbox.vue';
import ModalCertificateCreator from '@/views/dashboard/ModalCertificateCreator.vue';
import useful_functions from '@/providers/useful_functions.js';

export default {
  name: "NavbarComponent",
  inject: ['api_provider', 'urls_server'],
  components: {
    Breadcrumbs,
    UserInfo,
    FilterButton,
    VsudRightSideFilter,
    VsudSelect,
    VsudButtonVue,
    VsudDate,
    VsudInputVue,
    VsudSelectSearch,
    VsudTextarea,
    VsudSelectMultipleSearch,
    VsudCheckbox,
    ModalCertificateCreator,
  },
  props: {
    minNav: {
      type: Function,
      default: () => { }
    },
    textWhite: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      socket: {},
      roomName: "panel",
      isAuthenticated: '',
      showMenu: false,
      avatarDefault: avatarDefault,
      previousRouteName: null,

      showConfigFilter: false,
      showDateStartFilter: false,
      showDateEndFilter: false,
      withTime: false,
      showClientFilter: false,
      showZonesFilter: false,
      showZoneFilter: false,
      showTypeFilter: false,
      showStatusFilter: false,
      showPlanFilter: false,
      showTextFilter: false,
      showPlateFilter: false,
      showAliasFilter: false,
      showImeiFilter: false,
      showUserFilter: false,
      showNameFilter: false,
      showEmailFilter: false,
      showPhoneFilter: false,
      showBrandFilter: false,
      showModelFilter: false,
      showSpeedFilter: false,
      showSpeedTypeFilter: false,
      showMileageFilter: false,
      showMileageTypeFilter: false,
      showMinuteFilter: false,
      showMinuteTypeFilter: false,
      showPlatesFilter: false,
      showPlatesPlateFilter: false,
      showMassivePlatesFilter: false,
      showMassiveChasisNumbersFilter: false,
      showVehicleGroupsFilter: false,
      showCompanyFilter: false,
      protectOnlyFilter: false,
      showHighwayFilter: false,
      showPorchFilter: false,
      showStatusAlertFilter: false,
      showTypeAlertFilter: false,
      showTypeCommandFilter: false,
      showResultAlertFilter: false,
      showTypeRateFilter: false,
      showTypeZoneFilter: false,
      showTypeAreaFilter: false,
      showTypeDeviceFilter: false,
      showTypeVehicleFilter: false,

      canSeeCompany: false,
      canSeeClient: false,

      filter_name_list: "",
      all_field: [],
      default_field_filter: [],
      field_filter: [],
      default_date_start_filter: '',
      default_date_end_filter: '',
      date_start_filter: '',
      date_end_filter: '',
      country_filter: '',
      zones_filter: '',
      zone_filter: '',
      type_filter: '',
      status_filter: '',
      status_alert_filter: '',
      result_alert_filter: '',
      plan_filter: '',
      text_filter: '',
      plate_filter: '',
      alias_filter: '',
      imei_filter: '',
      user_filter: '',
      name_filter: '',
      email_filter: '',
      phone_filter: '',
      brand_filter: '',
      model_filter: '',
      type_alert_filter: '',
      type_command_filter : '',
      type_device_filter: '',

      speed_base: 120,
      mileage_base: 60,
      minute_base: 60,
      days_base: 7,

      speed_filter: 120,
      speed_type_filter: 1,
      mileage_filter: 60,
      mileage_type_filter: 0,
      minute_filter: 60,
      minute_type_filter: 0,
      days_filter: 7,
      days_type_filter: 0,
      massive_plates_filter: "",
      massive_chasis_numbers_filter: '',
      company_filter: "",
      client_filter: "",
      type_zone_filter: "",
      type_area_filter: "",

      countries: [],
      communes: [],
      types: [],
      statuses: [],
      statuses_alert: [{"id":1, "name": "Pendiente"}, {"id":2, "name": "Gestionada"}, {"id":5, "name": "Descartada"}],
      results_alert: [
        {"id":"stolen", "name": "Robado"},
        {"id":"recovered", "name": "Recuperado"},
        {"id":"rejected", "name": "Descartado"},
        {"id":"managed", "name": "Gestionada"},
        {"id":"pending", "name": "Pendiente"},
      ],
      types_alert: [
        {"id":1, "name": "Velocidad"},
        {"id":2, "name": "Entrada de zona"},
        {"id":4, "name": "Salida de zona"},
        {"id":5, "name": "Detención"},
        {"id":6, "name": "Sin señal"},
        {"id":7, "name": "Movimiento"},
        {"id":8, "name": "Sobreestadía"},
        {"id":9, "name": "Mantenimiento"},
      ],
      types_command: [
        {"id": "Habilitación de combustible", "name": "Habilitación de combustible"},
        {"id": "Corte combustible", "name": "Corte combustible"},
      ],      
      types_rate: [{"id": "Tarifa normal", "name": "Tarifa normal"}, {"id": "Tarifa base punta", "name": "Tarifa base punta"}, {"id": "Tarifa saturación", "name": "Tarifa saturación"}],
      //types_devices: [{"id": "67128b3f2a1ae3c170209694", "name": "ASD"}, {"id":"67128b3f2a1ae3c170209693", "name": "FGH"}, {"id":"67128b3f2a1ae3c170209692", "name": "JKL"}],
      types_devices: [],
      types_zones: [],
      types_areas: [{"id": 1, "name": "Círculo"}, {"id": 2, "name": "Poligono"}, {"id": 3, "name": "Linea"}, {"id": 4, "name": "Multipoligono"}, {"id": 5, "name": "Marcador circular"}],
      plans: [],
      brands: [],
      types_vehicles: [],
      models: [],
      highway_filter: [],
      porch_filter: [],
      plates_filter: [],
      plates_plate_filter: [],
      vehicle_groups_filter: [],
      ranges_types: [
        {id:0, name: "Igual a"},
        {id:1, name: "Superior o igual a"},
        {id:2, name: "Inferior o igual a"},
      ],
      load: false,
      loadBack: false,
      close: false,
      showPercentTypeFilter: false,
      showPercentFilter: false,
    };
  },
  computed: {
    ...mapGetters(["getName", "getProfile", "getAvatar"]),
    ...mapGetters('filter', [
      'filterNameList',
      'filterConfig',
      'defaultDateStartFilter',
      'defaultDateEndFilter',
      'dateStartFilter',
      'dateEndFilter',
      'allField',
      'defaultFieldFilter',
      'fieldFilter',
      'clientFilter',
      'zonesFilter',
      'zoneFilter',
      'typeFilter',
      'statusFilter',
      'planFilter',
      'textFilter',
      'imeiFilter',
      'plateFilter',
      'userFilter',
      'nameFilter',
      'emailFilter',
      'phoneFilter',
      'brandFilter',
      'modelFilter',
      'speedFilter',
      'speedTypeFilter',
      'mileageFilter',
      'mileageTypeFilter',
      'minuteFilter',
      'minuteTypeFilter',
      'daysFilter',
      'daysTypeFilter',
      'platesFilter',
      'platesPlateFilter',
      'massivePlatesFilter',
      'vehicleGroupsFilter',
      'companyFilter',
      'statusAlertFilter',
      'typeAlertFilter',
      'typeCommandFilter',
      'resultAlertFilter',
      'typeZoneFilter',
      'typeVehicleFilter'
    ]),
    name() {
      // El nombre y la foto propios llegan en la respuesta del login, antes de que el
      // modo demo este activo, asi que se reemplazan aca.
      return this.isDemo ? 'Usuario demo' : this.getName;
    },
    profile() {
      return this.getProfile;
    },
    avatar() {
      return this.isDemo ? '' : this.getAvatar;
    },
    isDemo() {
      // Deja a la vista que el usuario está viendo datos enmascarados.
      return this.$store.state.isDemo === true;
    },
    currentRouteName() {
      return this.$route.meta.name_breadcrumb || this.$route.name;
    },
    with_filter() {
      const routeHasFilter = this.$route.meta.with_filter || false;
      // console.log("with_filter  routeHasFilter", routeHasFilter)
      const hasActiveFilters = Object.keys(this.filterConfig).filter(key => key !== 'showConfigFilter').some(key => this.filterConfig[key]);
      // console.log("with_filter  hasActiveFilters", hasActiveFilters)
      return routeHasFilter && hasActiveFilters;
    },
    with_general_search() {
      return this.$route.meta.with_general_search || false;
    },
    with_save_filter() {
      return this.$route.meta.with_save_filter || false;
    },
    filteredModel() {
      if (this.brand_filter) {
        return this.models.filter(model => model.brand !== null && model.brand.toString() === this.brand_filter.toString());
      }
      return this.models;
    },
    disableSelect() {
      return !this.brand_filter;
    },
  },
  watch: {
    filterNameList(newVal) {
      // console.log("filterNameList this.filter_name_list", this.filter_name_list)
      if (newVal && newVal != ""){
        this.filter_name_list = newVal;
      }
    },
    showMenu(newValue) {
      if (newValue) {
        this.get_selects_options();
        this.get_selects_options_fastapi()
     }
    },
    currentRouteName(newRouteName) {
      if (newRouteName !== this.previousRouteName) {
        this.clear()
        this.previousRouteName = newRouteName;
      }
    },
    defaultDateStartFilter(newValue) {
      this.default_date_start_filter = newValue;
      this.date_start_filter = this.default_date_start_filter
    },
    defaultDateEndFilter(newValue) {
      this.default_date_end_filter = newValue;
      this.date_end_filter = this.default_date_end_filter
    },
    allField(newValue) {
      this.all_field = newValue;
    },
    defaultFieldFilter(newValue) {
      this.default_field_filter = newValue.map(String);
      this.field_filter = this.default_field_filter;
    },
    brandFilter(newVal, oldVal) {
      if (!oldVal == "" && newVal !== oldVal) {
        this.model_filter = 0;
      }
      this.brand_filter = newVal || '';
    },
    modelFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model_filter = newVal || '';
      }
    },
    clientFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.client_filter = newValue || '';
      }
    },
    zonesFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.zones_filter = newValue || '';
      }
    },
    zoneFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.zone_filter = newValue || '';
      }
    },
    typeFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.type_filter = newValue || '';
      }
    },
    statusFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.status_filter = newValue || '';
      }
    },
    planFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.plan_filter = newValue || '';
      }
    },
    textFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.text_filter = newValue || '';
      }
    },
    imeiFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.imei_filter = newValue || '';
      }
    },
    plateFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.plate_filter = newValue || '';
      }
    },
    aliasFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.alias_filter = newValue || '';
      }
    },
    userFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.user_filter = newValue || '';
      }
    },
    nameFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.name_filter = newValue || '';
      }
    },
    emailFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.email_filter = newValue || '';
      }
    },
    phoneFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.phone_filter = newValue || '';
      }
    },
    speedFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.speed_filter = newValue || '';
      }
    },
    speedTypeFilter(newValue, oldValue) {
      this.speed_type_filter = 1
      if (newValue !== oldValue) {
        this.speed_type_filter = newValue || 1;
      }
    },
    mileageFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.mileage_filter = newValue || '';
      }
    },
    mileageTypeFilter(newValue, oldValue) {
      this.mileage_type_filter = 0;
      if (newValue !== oldValue) {
        this.mileage_type_filter = newValue || 0;
      }
    },
    minuteFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.minute_filter = newValue || '';
      }
    },
    minuteTypeFilter(newValue, oldValue) {
      this.minute_type_filter = 0;
      if (newValue !== oldValue) {
        this.minute_type_filter = newValue || 0;
      }
    },
    daysFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.days_filter = newValue || '';
      }
    },
    daysTypeFilter(newValue, oldValue) {
      this.days_type_filter = 0;
      if (newValue !== oldValue) {
        this.days_type_filter = newValue || 0;
      }
    },
    platesFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.plates_filter = newValue || [];
      }
    },
    platesPlateFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.plates_plate_filter = newValue || [];
      }
    },
    massivePlatesFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.massive_plates_filter = newValue || '';
      }
    },
    massiveChasisNumbersFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.massive_chasis_numbers_filter = newValue || '';
      }
    },
    vehicleGroupsFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.vehicle_groups_filter = newValue || [];
      }
    },
    companyFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.company_filter = newValue || '';
      }
    },
    highwayFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.highway_filter = newValue || [];
      }
    },
    porchFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.porch_filter = newValue || [];
      }
    },
    statusAlertFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.status_alert_filter = newValue || '';
      }
    },
    typeAlertFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.type_alert_filter = newValue || '';
      }
    },
    typeCommandFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.type_command_filter = newValue || '';
      }
    },    
    resultAlertFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.result_alert_filter = newValue || '';
      }
    },
    typeRateFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.type_rate_filter = newValue || '';
      }
    },
    typeDeviceFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.type_device_filter = newValue || '';
      }
    },
    typeZoneFilter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.type_zone_filter = newValue || '';
      }
    },
    typeVehicleFilter(newVal, oldValue) {
      if (newVal !== oldValue) {
        this.type_vehicle_filter = newVal || '';
      }
    },

  },
  mounted() {
    this.minNav;
    this.isAuthenticated = this.$store.state.isAuthenticated

    this.canSeeCompany = this.$store.getters.canViewCompany
    this.canSeeClient = this.$store.getters.canViewClient
    // console.log("this.canSeeCompany", this.canSeeCompany)
    // console.log("this.canSeeClient", this.canSeeClient)
  },
  updated() {
    const navbar = document.getElementById("navbarBlur");
    if (navbar) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 10 && this.$store.state.isNavFixed) {
          navbar.classList.add("blur");
          navbar.classList.add("position-sticky");
          navbar.classList.add("shadow-blur");
        } else {
          navbar.classList.remove("blur");
          navbar.classList.remove("position-sticky");
          navbar.classList.remove("shadow-blur");
        }
      });
    }
  }, methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),
    ...mapMutations('filter', [
      'setFilterConfig',
      'setConfigFilter',
      'setDefaultDateStartFilter',
      'setDefaultDateEndFilter',
      'setDateStartFilter',
      'setDateEndFilter',
      'setAllField',
      'setDefaultFieldFilter',
      'setFieldFilter',
      'setClientFilter',
      'setZonesFilter',
      'setZoneFilter',
      'setTypeFilter',
      'setStatusFilter',
      'setPlanFilter',
      'setTextFilter',
      'setImeiFilter',
      'setPlateFilter',
      'setAliasFilter',
      'setUserFilter',
      'setNameFilter',
      'setEmailFilter',
      'setPhoneFilter',
      'setBrandFilter',
      'setModelFilter',
      'setSpeedFilter',
      'setSpeedTypeFilter',
      'setMileageFilter',
      'setMileageTypeFilter',
      'setMinuteFilter',
      'setMinuteTypeFilter',
      'setDaysFilter',
      'setDaysTypeFilter',
      'setPlatesFilter',
      'setPlatesPlateFilter',
      'setMassivePlatesFilter',
      'setMassiveChasisNumbersFilter',
      'setVehicleGroupsFilter',
      'setCompanyFilter',
      'setHighwayFilter',
      'setPorchFilter',
      'setStatusAlertFilter',
      'setTypeAlertFilter',
      'setTypeCommandFilter',
      'setResultAlertFilter',
      'setTypeRateFilter',
      'setTypeDeviceFilter',
      'setTypeZoneFilter',
      'setTypeAreaFilter',
      'setTypeVehicleFilter',
      'resetFilters'
    ]),
    savePreferences() {
      // if (this.showConfigFilter) {
            this.setFieldFilter(this.field_filter);
            this.default_field_filter = this.field_filter
            this.close = false
        // }
    },
    async savePreferencesFilter() {
        let filterData = {};

        if (this.showClientFilter) filterData.client_filter = this.client_filter;
        if (this.showImeiFilter) filterData.imei_filter = this.imei_filter;
        if (this.showStatusFilter) filterData.status_filter = this.status_filter;
        if (this.showBrandFilter) filterData.brand_filter = this.brand_filter;
        if (this.showModelFilter) filterData.model_filter = this.model_filter;
        if (this.showPlateFilter) filterData.plate_filter = this.plate_filter;
        if (this.showAliasFilter) filterData.alias_filter = this.alias_filter;
        if (this.showPlatesFilter) filterData.plates_filter = this.plates_filter;
        if (this.showPlatesPlateFilter) filterData.plates_plate_filter = this.plates_plate_filter;        
        if (this.showMassivePlatesFilter) filterData.massive_plates_filter = this.massive_plates_filter;
        if (this.showMassiveChasisNumbersFilter) filterData.massive_chasis_numbers_filter = this.massive_chasis_numbers_filter;
        if (this.showVehicleGroupsFilter) filterData.vehicle_groups_filter = this.vehicle_groups_filter;
        if (this.showTextFilter) filterData.text_filter = this.text_filter;
        // if (this.showDateStartFilter) filterData.date_start_filter = this.date_start_filter;
        // if (this.showDateEndFilter) filterData.date_end_filter = this.date_end_filter;
        if (this.showZonesFilter) filterData.zones_filter = this.zones_filter;
        if (this.showZoneFilter) filterData.zone_filter = this.zone_filter;
        if (this.showTypeFilter) filterData.type_filter = this.type_filter;
        if (this.showPlanFilter) filterData.plan_filter = this.plan_filter;
        if (this.showUserFilter) filterData.user_filter = this.user_filter;
        if (this.showNameFilter) filterData.name_filter = this.name_filter;
        if (this.showEmailFilter) filterData.email_filter = this.email_filter;
        if (this.showPhoneFilter) filterData.phone_filter = this.phone_filter;
        if (this.showSpeedFilter) filterData.speed_filter = this.speed_filter;
        if (this.showSpeedTypeFilter) filterData.speed_type_filter = this.speed_type_filter;
        if (this.showMileageFilter) filterData.mileage_filter = this.mileage_filter;
        if (this.showMileageTypeFilter) filterData.mileage_type_filter = this.mileage_type_filter;
        if (this.showMinuteFilter) filterData.minute_filter = this.minute_filter;
        if (this.showMinuteTypeFilter) filterData.minute_type_filter = this.minute_type_filter;
        if (this.showDaysFilter) filterData.days_filter = this.days_filter;
        if (this.showDaysTypeFilter) filterData.days_type_filter = this.days_type_filter;
        if (this.showCompanyFilter) filterData.company_filter = this.company_filter;
        if (this.showHighwayFilter) filterData.highway_filter = this.highway_filter;
        if (this.showPorchFilter) filterData.porch_filter = this.porch_filter;
        if (this.showStatusAlertFilter) filterData.status_alert_filter = this.status_alert_filter;
        if (this.showTypeAlertFilter) filterData.type_alert_filter = this.type_alert_filter;
        if (this.showTypeCommandFilter) filterData.type_command_filter = this.type_command_filter;
        if (this.showResultAlertFilter) filterData.result_alert_filter = this.result_alert_filter;
        if (this.showTypeRateFilter) filterData.type_rate_filter = this.type_rate_filter;   
        if (this.showTypeDeviceFilter) filterData.type_device_filter = this.type_device_filter;
        if (this.showTypeZoneFilter) filterData.type_zone_filter = this.type_zone_filter;
        if (this.showTypeAreaFilter) filterData.type_area_filter = this.type_area_filter;
        if (this.showTypeVehicleFilter) filterData.type_vehicle_filter = this.type_vehicle_filter;

        let postData = {
            filter_name_list: this.filter_name_list,
            filters_data: JSON.stringify(filterData),
        };
        // console.log("-------------postData", postData)
        try {
            const response = await this.api_provider.post(this.urls_server.save_preference_filter, postData);
            if (response.data && response.data.status) {
                Swal.fire({
                    title: 'Éxito',
                    text: 'La configuración del filtro se ha guardado exitosamente.',
                    icon: 'success',
                    confirmButtonColor: '#4821B0',
                    confirmButtonText: 'OK'
                });
            }else{
              Swal.fire({
                    title: 'Error',
                    text: 'No se pudo guardar la configuración del filtro. Por favor, inténtelo de nuevo.',
                    icon: 'error',
                    confirmButtonColor: '#4821B0',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: 'Se produjo un error al intentar guardar la configuración del filtro. Por favor, verifique su conexión e intente de nuevo.',
                icon: 'error',
                confirmButtonColor: '#4821B0',
                confirmButtonText: 'OK'
            });
            console.log("Error savePreferencesFilter: ", error);
        }
    },
    closePreferences() {
      this.field_filter = this.default_field_filter
      this.close = true
    },
    modalOpen(){
      // console.log("modalOpen")
      this.$refs.modalCertificateCreator.get_selects_options()
    },
    isFieldSelected(fieldId) {
      // console.log("this.field_filter selected", this.field_filter)
      return this.field_filter.includes(String(fieldId));
    },
    toggleCheckboxField(fieldId) {
      let originalDefaultFilter = [...this.default_field_filter];
      const stringFieldId = String(fieldId);
      // console.log("------------------this.field_filter 1", this.field_filter);

      // Verificar si el fieldId ya está en el filtro de campos
      if (this.field_filter.includes(stringFieldId)) {
          // Si el fieldId ya está presente, se elimina (deselección del checkbox)
          this.field_filter = this.field_filter.filter(id => id !== stringFieldId);
      } else {
          // Si el fieldId no está presente, se agrega (selección del checkbox)
          this.field_filter.push(stringFieldId);
      }
      // console.log("------------------this.field_filter 2", this.field_filter);
      if (this.close) {
          // console.log("originalDefaultFilter", originalDefaultFilter);
          this.default_field_filter = originalDefaultFilter;
      }
    },
    async get_selects_options() {
      // console.log(":::::::::get_selects_options")
      try {
        const response = await this.api_provider.post(this.urls_server.get_filters_options, {}, "get");
        if (response && response.data) {
          // this.types = this.showTypeFilter ? response.data.types : []
          this.statuses = this.showStatusFilter ? response.data.statuses: []
          this.brands = this.showBrandFilter ? response.data.brands: []
          this.models = this.showModelFilter ? response.data.models: []
          this.types_devices = this.showTypeDeviceFilter ? response.data.types_devices: []
          this.types_vehicles = this.showTypeVehicleFilter ? response.data.types_vehicles: []
          // console.log("get_selects_options ", this.models)
        }

      } catch (error) {
        console.log("Error get_selects_options: ", error);
      }
    },
    async get_selects_options_fastapi() {
      // console.log(":::::::::get_selects_options_fastapi");
      var companyFilter = securedWebStorage.getItem("id_company")
      const system_role = securedWebStorage.getItem("role")
      const user_id = securedWebStorage.getItem("id")

      if( system_role == 'WISETRACK_ADMIN'){
          companyFilter = this.company_filter ? this.company_filter : ""
      }
      try {

        const url = `/type_zones/?page=1&limit=9999&sortText=name&sortDir=asc&company=${companyFilter}&user_id=${user_id}`;
        try {
            const response = await this.api_provider.post_bff_fastapi(url, {}, "get")
            if (response && response.data) {
              this.types_zones = response.data.data.type_zones;
            }
        } catch (error) {
            console.log("Error get_type_zone_list: ", error);
        }


      } catch (error) {
        console.log("Error get_selects_options_fastapi: ", error);
      }
    },
    updateConfigFilter() {
      for (const [key, value] of Object.entries(this.filterConfig)) {
        if (this[key] !== value) {
          this[key] = value;
        }
      }
    },
    viewProfile() {
      const id = securedWebStorage.getItem("id")
      this.$router.push({ name: "ProfilePanel", params: { id: id } });
    },
    filterOpen() {
      this.canSeeCompany = this.$store.getters.canViewCompany
      this.canSeeClient = this.$store.getters.canViewClient
      this.showMenu = true
      this.updateConfigFilter()
    },
    toggleSidebar() {
      // console.log('toggleSidebar')
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    clicked() {
      this.load = true;
      this.$emit("update:load", true);
      // if (this.showConfigFilter) this.setConfigFilter(this.field_filter);
      if (this.showDateStartFilter) this.setDateStartFilter(this.date_start_filter);
      if (this.showDateEndFilter) this.setDateEndFilter(this.date_end_filter);
      if (this.showClientFilter) this.setClientFilter(this.client_filter);
      if (this.showZonesFilter) this.setZonesFilter(this.zones_filter);
      if (this.showZoneFilter) this.setZoneFilter(this.zone_filter);
      if (this.showTypeFilter) this.setTypeFilter(this.type_filter);
      if (this.showStatusFilter) this.setStatusFilter(this.status_filter);
      if (this.showPlanFilter) this.setPlanFilter(this.plan_filter);
      if (this.showTextFilter) this.setTextFilter(this.text_filter);
      if (this.showPlateFilter) this.setPlateFilter(this.plate_filter);
      if (this.showAliasFilter) this.setAliasFilter(this.alias_filter);
      if (this.showImeiFilter) this.setImeiFilter(this.imei_filter);
      if (this.showUserFilter) this.setUserFilter(this.user_filter);
      if (this.showNameFilter) this.setNameFilter(this.name_filter);
      if (this.showEmailFilter) this.setEmailFilter(this.email_filter);
      if (this.showPhoneFilter) this.setPhoneFilter(this.phone_filter);
      if (this.showBrandFilter) this.setBrandFilter(this.brand_filter);
      if (this.showModelFilter) this.setModelFilter(this.model_filter);
      if (this.showSpeedFilter) this.setSpeedFilter(this.speed_filter);
      if (this.showSpeedTypeFilter) this.setSpeedTypeFilter(this.speed_type_filter);
      if (this.showMileageFilter) this.setMileageFilter(this.mileage_filter);
      if (this.showMileageTypeFilter) this.setMileageTypeFilter(this.mileage_type_filter);
      if (this.showMinuteFilter) this.setMinuteFilter(this.minute_filter);
      if (this.showMinuteTypeFilter) this.setMinuteTypeFilter(this.minute_type_filter);
      if (this.showDaysFilter) this.setDaysFilter(this.days_filter);
      if (this.showDaysTypeFilter) this.setDaysTypeFilter(this.days_type_filter);
      if (this.showPlatesFilter) this.setPlatesFilter(this.plates_filter);
      if (this.showPlatesPlateFilter) this.setPlatesPlateFilter(this.plates_plate_filter);
      if (this.showMassivePlatesFilter) this.setMassivePlatesFilter(useful_functions.normalizeMassivePlatesInput(this.massive_plates_filter));
      if (this.showMassiveChasisNumbersFilter) this.setMassiveChasisNumbersFilter(useful_functions.normalizeMassiveVinInput(this.massive_chasis_numbers_filter));
      if (this.showVehicleGroupsFilter) this.setVehicleGroupsFilter(this.vehicle_groups_filter);
      if (this.showCompanyFilter) this.setCompanyFilter(this.company_filter);
      if (this.showHighwayFilter) this.setHighwayFilter(this.highway_filter);
      if (this.showPorchFilter) this.setPorchFilter(this.porch_filter);
      if (this.showStatusAlertFilter) this.setStatusAlertFilter(this.status_alert_filter);
      if (this.showTypeAlertFilter) this.setTypeAlertFilter(this.type_alert_filter);
      if (this.showTypeCommandFilter) this.setTypeCommandFilter(this.type_command_filter);
      if (this.showResultAlertFilter) this.setResultAlertFilter(this.result_alert_filter);
      if (this.showTypeRateFilter) this.setTypeRateFilter(this.type_rate_filter);  
      if (this.showTypeDeviceFilter) this.setTypeDeviceFilter(this.type_device_filter);   
      if (this.showTypeZoneFilter) this.setTypeZoneFilter(this.type_zone_filter);     
      if (this.showTypeAreaFilter) this.setTypeAreaFilter(this.type_area_filter); 
      if (this.showTypeVehicleFilter) this.setTypeVehicleFilter(this.type_vehicle_filter); 

      setTimeout(() => {
        this.load = false;
        this.$emit("update:load", false);
      }, 750);
      this.$refs.rightSideFilter.closeFilter();
    },
    clear_clicked() {
      this.clear()
      this.date_start_filter = this.default_date_start_filter;
      this.date_end_filter = this.default_date_end_filter;
      this.field_filter = this.default_field_filter;
      this.clicked()

      this.load = false;
      this.$emit("update:load", false);
      this.loadBack = true;
      this.$emit("update:load", true);
      setTimeout(() => {
        this.loadBack = false;
        this.$emit("update:load", false);
      }, 450);
    },
    clear() {
      this.client_filter = ""
      this.zones_filter = ""
      this.zone_filter = ""
      this.type_filter = ""
      this.status_filter = ""
      this.status_alert_filter = ""
      this.result_alert_filter = ""
      this.plan_filter = ""
      this.text_filter = ""
      this.plate_filter = ""
      this.alias_filter = ""
      this.imei_filter = ""
      this.user_filter = ""
      this.name_filter = ""
      this.email_filter = ""
      this.phone_filter = ""
      this.brand_filter = ""
      this.model_filter = ""
      this.speed_filter = this.speed_base
      this.speed_type_filter = 1
      this.mileage_filter = this.mileage_base
      this.mileage_type_filter = 0
      this.minute_filter = this.minute_base
      this.minute_type_filter = 0
      this.days_filter = this.days_base
      this.days_type_filter = 0
      this.plates_filter = []
      this.plates_plate_filter = []
      this.massive_plates_filter = ""
      this.massive_chasis_numbers_filter = ""
      this.vehicle_groups_filter = []
      this.company_filter = ""
      this.highway_filter = []
      this.porch_filter = []
      this.type_alert_filter = ""
      this.type_command_filter = ""
      this.type_rate_filter = ""
      this.type_device_filter = ""
      this.type_zone_filter = ""
      this.type_area_filter = ""
      this.type_vehicle_filter = ''
    },
    limitPercentRange(event) {
      let value = parseFloat(event.target.value);

      if (value > 90) {
        this.days_filter = 90;
      } else if (value < 0) {
        this.days_filter = 0;
      } else {
        this.days_filter = value;
      }
    },
  },
};
</script>

<style scoped>
span.input-group-text {
  margin-left: 2px;
}

.form-control {
  padding-left: 35px !important;
}

.navbar-main {
  background: linear-gradient(180deg, #26343e 0%, #212e36 100%);
  position: sticky;
  top: 0;
  z-index: 11;
}

#navbarBlur {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.new-certificate-button{
  max-height: 40.39px;
  height: 40.39px;
  align-items: center !important;
  /* degradado teal + sombra suave (reemplaza el fondo plano) */
  background-image: linear-gradient(135deg, #45bfc6 0%, #22a0a9 100%) !important;
  background-color: transparent !important;
  border: none !important;
  color: #ffffff !important;
  box-shadow: 0 8px 18px rgba(34, 160, 169, 0.55);
  transition: box-shadow 0.2s ease, filter 0.2s ease;
}
.new-certificate-button:hover{
  box-shadow: 0 10px 22px rgba(34, 160, 169, 0.65);
  filter: brightness(1.05);
}
.new-certificate-button .ri-file-text-line{
  font-size: 1.1rem;
  margin: 0;
  padding: 0 3px 0 0;
}
.new-certificate-button span{
  display: inline-flex;
  align-items: center;
}

@media (max-width: 850px) {
  #search {
    width: 100%;
    margin-right: 1rem;
  }
}

@media (max-width: 720px) {
  #search {
    margin-right: 1rem;
  }
}

.button-containers-end {
  width: calc(100%);
  margin: 1rem 0;
  padding: 1.5rem 1.5rem 3.5rem;
  padding: 0;
  gap: 0.8rem;
  display: flex;
  justify-content: center;
}
</style>

<style>
div.button-containers-end .btn-outline-secondary i{
  font-size: 18px!important;
  padding: 0!important;
  margin: 0 8px!important;
}

button.filter-button-primary {
  width: calc(100%)!important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Navbar superior oscuro (mismo tono que el sidebar) */
#navbarBlur.blur {
  background: linear-gradient(180deg, #26343e 0%, #212e36 100%) !important;
}
#navbarBlur h5,
#navbarBlur .name {
  color: #ffffff !important;
}
#navbarBlur .profile {
  color: #c7d0d6 !important;
}
#navbarBlur .sidenav-toggler-line {
  background-color: #ffffff !important;
}
</style>